function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "85DF5EB5-590C-4F2A-917F-7ABC1BD68BDC");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Design-System",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons_IB_exportar",
  transform: "translate(-40.000000, -368.000000)",
  fill: "#00C189",
  stroke: "#00C189",
  strokeWidth: 0.3
}, /*#__PURE__*/React.createElement("path", {
  d: "M56.5812083,369 C57.3639167,369 58,369.653818 58,370.456727 L58,373.363636 L58,374.090909 L58,383.542545 C58,384.346182 57.3632083,385 56.5805,385 L42.4187917,385 C41.6367917,385 41,384.346909 41,383.543273 L41,370.456727 C41,369.653818 41.6367917,369 42.4187917,369 L56.5812083,369 Z M57.291,374.09 L41.708,374.09 L41.7083333,383.543273 C41.7083333,383.945455 42.0270833,384.272727 42.4187917,384.272727 L56.5805,384.272727 C56.9729167,384.272727 57.2916667,383.945455 57.2916667,383.542545 L57.291,374.09 Z M56.5812083,369.727273 L42.4187917,369.727273 C42.0270833,369.727273 41.7083333,370.054545 41.7083333,370.456727 L41.708,373.363 L57.291,373.363 L57.2916667,370.456727 C57.2916667,370.054545 56.9729167,369.727273 56.5812083,369.727273 Z",
  id: "ic_dropcalendario"
})));

var SvgIcDropcalendario = function SvgIcDropcalendario(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "18px",
    viewBox: "0 0 19 18",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcDropcalendario, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_dropcalendario.61049baa.svg";
export { ForwardRef as ReactComponent };